import { Injectable, inject } from '@angular/core';
import {ApplicationInsightsService} from './application-insights.service';
import {MsalService} from "@azure/msal-angular";
import {AccountInfo, InteractionRequiredAuthError, SilentRequest} from "@azure/msal-browser";
import {environment} from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly applicationInsightsService = inject(ApplicationInsightsService);
  private readonly msalService = inject(MsalService);


  token: string;
  isAuth = false;
  isAuthBDD = false;

  signOutUser() {
    localStorage.clear();
    this.token = null;
    this.isAuth = false;
    this.isAuthBDD = false;
    this.applicationInsightsService.clearUserId();
  }

  getAccount(): AccountInfo | null {
    return this.msalService.instance.getActiveAccount();
  }

  async acquireTokenSilent(): Promise<void> {
    const account = this.getAccount();
    if (!account) {
      throw new Error('No account found');
    }

    const silentRequest: SilentRequest = {
      account,
      scopes: environment.azureb2c.scopes,
      authority: environment.azureb2c.authorityUrl,
      forceRefresh: true
    };

    try {
      await this.msalService.instance.acquireTokenSilent(silentRequest);
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        // Silent acquisition failed, require user interaction to refresh token
        this.acquireTokenWithInteraction();
      } else {
        throw error;
      }
    }
  }

  // Fallback method for interactive token acquisition
  acquireTokenWithInteraction(): void {
    const account = this.getAccount();
    if (!account) {
      throw new Error('No account found for interaction');
    }

    const request = {
      scopes: environment.azureb2c.scopes,
      authority: environment.azureb2c.authorityUrl
    };

    this.msalService.instance.acquireTokenRedirect(request);
  }
}
